$(document).ready(function() {  
  $(document).on('click', '.boost-sd__product-swatch-option.opavailable-true', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var vid = $(this).attr('rel_href');
    var pid = $(this).attr('prel_href');
    location.href = "/products/"+pid+"?variant="+vid;
  });

  $('.readmore').click(function (event) {
    event.preventDefault();
    $(this).parents('.rte').find('.product-description-full').show();
    $(this).parents('.rte').find('.product-description-short').hide();
  });
  $('.readless').click(function (event) {
    event.preventDefault();
    $(this).parents('.rte').find('.product-description-full').hide();
    $(this).parents('.rte').find('.product-description-short').show();
  }); 
  
  if ($('body').hasClass('template-suffix-product-custom') || $('body').hasClass('template-suffix-custom-preorder')) {
    setTimeout(function() {
      if ($('.standard-options-unavailable').val() == 'true' || $('body').hasClass('pingpopup')) {
        $('button.tablinks[data-attr="custom-options"]').click();
      } else {
        $('.tablinks[data-attr="standard-options"]').trigger('click');    
      }
      $('.tab-custom-stan-option .loading__spinner_ele').addClass('hidden');
      $('.tab-custom-stan-option').removeClass('loader_ele');
    }, 750);
  } else {
      if ($('body').hasClass('template-suffix-custom-preorder') || $('body').hasClass('template-suffix-dropdown-ui')) {
        $('.variant-wrapper.elevate-index-1').find('select').val($('.variant-wrapper.elevate-index-1').find('select').find('option:first-child').val()).change();
        var isselectAva1 = $('.variant-wrapper.elevate-index-1 select').find('option[value="Select"]').length;
        var isselectAva2 = $('.variant-wrapper.elevate-index-2 select').find('option[value="Select"]').length;
        var isselectAva3 = $('.variant-wrapper.elevate-index-3 select').find('option[value="Select"]').length;
        if (isselectAva1 == 0) {
          $('.variant-wrapper.elevate-index-1').find('select').prepend('<option disabled value="Select">Select</option>')
        }
        if (isselectAva2 == 0) {
          $('.variant-wrapper.elevate-index-2').find('select').prepend('<option disabled value="Select">Select</option>')
        }
        if (isselectAva3 == 0) {
          $('.variant-wrapper.elevate-index-3').find('select').prepend('<option disabled value="Select">Select</option>')
        }
        $('.variant-wrapper.elevate-index-1').find('select').val('Select');
        $('.variant-wrapper.elevate-index-2').find('select').val('Select');
        $('.variant-wrapper.elevate-index-3').find('select').val("Select");
  
        var firstAvVariant = $('#first_available_selected_variant').attr('vid');
        
        $('form input[name="id"]').val(firstAvVariant);
        $('.qty-btn-wrapper .product-form__submit.button').attr('disabled', 'disabled');
        $('.qty-btn-wrapper .product-form__submit.button').addClass('hidden');
        $('.qty-btn-wrapper .product-select-options').addClass('active');
        //$('.qty-btn-wrapper .product-form__submit.button span').html('Select options');
      }
  }

  $(document).on('click', '.boost-sd__product-item .arne-color-swatch-element', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var ur = $(this).attr('rel_handle');
    location.href = ur;
  })
  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      $('#backtotopbutton').addClass('show');
    } else {
      $('#backtotopbutton').removeClass('show');
    }
  });
  
  $('#backtotopbutton').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({scrollTop:0}, '300');
  });

  $('a.forgot-password-btn, a[href="#login"]').click(function() {
    setTimeout(function() {
      window.scrollTo({
          top: 0,
          behavior: 'smooth'
      })
    }, 50);
  });
  
 $('.togglepassword').click(function() {
   $(this).toggleClass('toggled');
   var type = $(this).siblings('input').attr('type');
   if (type == 'password') {
     $(this).siblings('input').attr('type', 'text');
   } else {     
     $(this).siblings('input').attr('type', 'password');
   }
 });
  
  $(document).on('click', 'label.boost-sd__radio-label', function() {
    var href = $(this).attr('data_href');
    location.href = href;
  });

  $('.tab_btn_ele').click(function() {
    var atr = $(this).attr('datatab');
    $(this).parents('.page-width').find('.tab_btn_ele').removeClass('active');
    $(this).parents('.collection').find('.tab_btn_ele').removeClass('active');
    $(this).addClass('active');
    $(this).parents('.page-width').find('.tab_wrapper_ele').hide();
    $(this).parents('.collection').find('.tab_wrapper_ele').hide();
    $('.tab_wrapper_ele[datatab="'+atr+'"]').fadeIn();
    $('.collectionblocks_section').hide();
    $('.collectionblocks_section[blocktype="'+atr+'"]').fadeIn();
  });  
  
  var price = $('.price__container').html();
  var btn = $('.product-form__submit').html();
  var atr = $('.product-form__submit').attr('disabled');
  
  if (atr) {
    $('.btn-wrp-btm button').attr('disabled', atr);
    btn = $('a.product-form__submit-notify.klaviyo-bis-trigger').html();
  } else {
    $('.btn-wrp-btm button').removeAttr('disabled');
  }
  $('.price-wrp-btm-inner').html(price);
  $('.btn-wrp-btm button').html(btn);
  
  $(window).on('scroll', function() {
    if ($('body').hasClass('template-product')) {
      var scrollTop = $(this).scrollTop(); 
      var price = $('.price__container').html();
      var btn = $('.product-form__submit').html();
      var atr = $('.product-form__submit').attr('disabled');
      
      var topDistance = $('.product-form__buttons').offset().top;
      if (atr) {
        $('.btn-wrp-btm button').attr('disabled', atr);
        btn = $('a.product-form__submit-notify.klaviyo-bis-trigger').html();
      } else {
        $('.btn-wrp-btm button').removeAttr('disabled');
      }
      $('.price-wrp-btm-inner').html(price);
      $('.btn-wrp-btm button').html(btn);
      
      if ( (topDistance - 50) < scrollTop ) {
        $('.bottom-button-wrapper').addClass('fixed');
      } else {
        $('.bottom-button-wrapper').removeClass('fixed');
      }
    }
  });

  $(document).on('click', '.bottom-button-wrapper .product-form__submit', function() {    
    // console.log('here')
    $(this).find('span').hide();
    $(this).find('.loading__spinner').removeClass('hidden');
    var atr = $('.product-form__submit').attr('disabled');
    if (atr) {
      $('.qty-btn-wrapper .product-form__submit').click();
    } else {
      $('a.product-form__submit-notify.klaviyo-bis-trigger').click();
    }
  })

  $(window).on("resize", function (e) {
      checkScreenSize();
  });

  checkScreenSize();
  var newWindowWidth = $(window).width();
  if (newWindowWidth < 768) {
    $('.block-type-link_list h2.footer-block__heading.inline-richtext').click(function() {
      $(this).siblings('ul.footer-block__details-content').slideToggle();
    })
  }
  function checkScreenSize(){
      var newWindowWidth = $(window).width();
      if (newWindowWidth < 768) {        
        $('.fitting_popup_innerwrapper').addClass('owl-carousel');
        $('.fitting_popup_innerwrapper').owlCarousel({
          nav:false,
          dots:true,
          lazyLoad:true,
          autoplay: true,
          loop:false,
          items:1
        });
      }
  }
  
  $(document).on('click', '.cartClear', function () {
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function() { 
        location.reload();
      },
      error: function(XMLHttpRequest, textStatus) {
        /* error code */
      }
    });
    return false;
  });

  var addStagePadding = 0;
  var addStagePaddingItem = 2;
  if ($('body').hasClass('template-suffix-black-friday')) {
    addStagePadding = 40;
    addStagePaddingItem = 1;
  }
  $('.featured_collection_carousel').owlCarousel({
    loop: true,
    dots: false,
    margin:16,
    responsiveClass:true,
    nav:true,
    responsive:{
      0:{
          
          items:addStagePaddingItem,
          stagePadding: addStagePadding
      },
      600:{
          items:3
      },
      1000:{
          items: 4
      }
    }
  });
  
  $('.clarks-golf-centre').owlCarousel({
    margin:10,
    nav:false,
    dots:false,
    lazyLoad:true,
    autoplay: true,
    stagePadding: 40,
    loop:true,
    items:1
  });

  
  $('.mediazoom.owl-carousel').owlCarousel({
    nav:true,
    dots:false,
    lazyLoad:true,
    autoplay: false,
    items:1
  });
    
  $('.blogs_grid_wrapper').owlCarousel({
    nav:false,
    dots:false,
    lazyLoad:true,
    autoplay: false,
    loop:false,
    margin: 16,
    stagePadding: 50,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:2
      },
      1000:{
        items:3
      }
    }
  });
  
  
  var owlnxt = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">';
  owlnxt += '<circle cx="14" cy="14.7793" r="13.25" stroke="#202020" stroke-width="1.5"/>';
  owlnxt += '<path d="M11.625 20.3867L17.8171 14.7107L11.625 9.0346" stroke="#202020" stroke-width="1.5" stroke-linecap="square"/></svg>';
  var owlprev = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">';
  owlprev += '<circle cx="14" cy="14.7793" r="13.25" transform="rotate(-180 14 14.7793)" stroke="#202020" stroke-width="1.5"/>';
  owlprev += '<path d="M16.375 9.17188L10.1829 14.8479L16.375 20.524" stroke="#202020" stroke-width="1.5" stroke-linecap="square"/></svg>';

  $('.featured_collection_carousel .owl-next').html(owlnxt);
  $('.featured_collection_carousel .owl-prev').html(owlprev);

  var owlnxtFeat = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="14" fill="#0093B4"/>';
  owlnxtFeat += '<path d="M12.8984 18L16.8984 14L12.8984 10" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var owlprevFeat = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="14" transform="rotate(-180 14 14)" fill="#0093B4" />';
  owlprevFeat += '<path d="M14.8984 10L10.8984 14L14.8984 18" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  
  $('.template-suffix-black-friday .featured_collection_carousel .owl-next').html(owlnxtFeat);
  $('.template-suffix-black-friday .featured_collection_carousel .owl-prev').html(owlprevFeat);
  
  $('.mediazoom.owl-carousel .owl-next').html(owlnxt);
  $('.mediazoom.owl-carousel .owl-prev').html(owlprev);
  
  $('.readmore').click(function (event) {
    event.preventDefault();
    $(this).parents('.Rte').find('.product-description-full').show();
    $(this).parents('.Rte').find('.product-description-short').hide();
  });
  $('.readless').click(function (event) {
    event.preventDefault();    
    $(this).parents('.Rte').find('.product-description-full').hide();
    $(this).parents('.Rte').find('.product-description-short').show();
  });  

  $('button.collapsible-trigger').click(function() {
    $(this).siblings('.collapsible-content.collapsible-content--all').slideToggle();
  });

  // Custom product option
  $('.tab-custom-stan-option .tablinks').click(function(e) {
    e.preventDefault();
    var atr = $(this).attr('data-attr');
    $('.tab-custom-stan-option .tablinks').removeClass('active');
    $(this).addClass('active');

    if (atr == 'custom-options') {
      
      var custom_v = $('.custom_data_product').val();      
      var custom_price = parseFloat($('.custom_data_product').attr('price'));
      var custom_cprice = parseFloat($('.custom_data_product').attr('cprice'));
      
      $('#sel-custom-options').html($('#customoptions').html());
      var v = '';
      
      $('.standard-options-cont .variant-wrapper select').each(function() {
      	$(this).find('option').removeAttr('selected');
        $(this).find('option[value="custom"]').attr('selected', 'selected');
        $(this).val('custom');
        $(this).change();
      });

      $('.custom-options-cont select').trigger('change', { tab: true });
      $('form input[name="id"]').val(custom_v);
      $('#orderdeadline').hide();
      $('#dynamicbuttonwrp').hide();
      $('form .product-form__submit').attr('disabled', 'disabled');
      $('form .product-form__submit').addClass('hidden');
      $('.qty-btn-wrapper .product-select-options').addClass('active');
      //$('.qty-btn-wrapper .product-form__submit.button span').html('Select options');
      $('span.stock_info-wrp').hide();
      $('.delivery_status_badge').hide();

      $('.tabcontent[data-attr="custom-options"] select').each(function() {
        if ($(this).val() != 'Select') {
          $(this).prepend('<option disabled value="Select" selected>Select</option>');
        }
      });

      if (custom_cprice && custom_cprice > custom_price) {
        var v = '<div class="price__sale">';
            v += '<span class="visually-hidden visually-hidden--inline">Sale price</span>';
            v += '<span class="price-item price-item--sale price-item--last">';
            v += '£'+(custom_price/100).toFixed(2);
            v += '</span>';
            v += '<span class="visually-hidden visually-hidden--inline">Regular price</span>';
            v += '<span>';
            v += '<s class="price-item price-item--regular">';
            v += '£'+(custom_cprice/100).toFixed(2);
            v += '</s>';
            v += '</span>';
            v += '</div>';
            $('.product__info-wrapper .price__container').html(v);
          $('.product__info-wrapper .price').addClass('price--on-sale');
      } else {
          $('.product__info-wrapper .price').removeClass('price--on-sale');
          var vp = '<div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>';
          vp += '<span class="price-item price-item--regular">';
          vp += '£'+(custom_price/100).toFixed(2);
          vp += '</span>';
          vp += '</div>';
          $('.product__info-wrapper .price__container').html(vp);
      }
    } else {
      
      var custom_price = parseFloat($('#first_available_selected_variant').attr('price'));
      var custom_cprice = parseFloat($('#first_available_selected_variant').attr('cprice'));
      
      if (custom_cprice && custom_cprice > custom_price) {
        var v = '<div class="price__sale">';
            v += '<span class="visually-hidden visually-hidden--inline">Sale price</span>';
            v += '<span class="price-item price-item--sale price-item--last">';
            v += '£'+(custom_price/100).toFixed(2);
            v += '</span>';
            v += '<span class="visually-hidden visually-hidden--inline">Regular price</span>';
            v += '<span>';
            v += '<s class="price-item price-item--regular">';
            v += '£'+(custom_cprice/100).toFixed(2);
            v += '</s>';
            v += '</span>';
            v += '</div>';
            $('.product__info-wrapper .price__container').html(v);
          $('.product__info-wrapper .price').addClass('price--on-sale');
      } else {
          $('.product__info-wrapper .price').removeClass('price--on-sale');
          var vp = '<div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>';
          vp += '<span class="price-item price-item--regular">';
          vp += '£'+(custom_price/100).toFixed(2);
          vp += '</span>';
          vp += '</div>';
          $('.product__info-wrapper .price__container').html(vp);
      }
      $('span.stock_info-wrp').show();
      $('.delivery_status_badge').show();
      $('#sel-custom-options').html('');
      
      $('.variant-wrapper.elevate-index-1').find('select').val($('.variant-wrapper.elevate-index-1').find('select').find('option:first-child').val()).change();
      
      var isselectAva1 = $('.variant-wrapper.elevate-index-1 select').find('option[value="Select"]').length;
      var isselectAva2 = $('.variant-wrapper.elevate-index-2 select').find('option[value="Select"]').length;
      var isselectAva3 = $('.variant-wrapper.elevate-index-3 select').find('option[value="Select"]').length;
      if (isselectAva1 == 0) {
        $('.variant-wrapper.elevate-index-1').find('select').prepend('<option disabled value="Select">Select</option>')
      }
      if (isselectAva2 == 0) {
        $('.variant-wrapper.elevate-index-2').find('select').prepend('<option disabled value="Select">Select</option>')
      }
      if (isselectAva3 == 0) {
        $('.variant-wrapper.elevate-index-3').find('select').prepend('<option disabled value="Select">Select</option>')
      }
      $('.variant-wrapper.elevate-index-1').find('select').val('Select');
      $('.variant-wrapper.elevate-index-2').find('select').val('Select');
      $('.variant-wrapper.elevate-index-3').find('select').val("Select");

      var firstAvVariant = $('#first_available_selected_variant').attr('vid');
      
      $('form input[name="id"]').val(firstAvVariant);
      $('.qty-btn-wrapper .product-form__submit.button').attr('disabled', 'disabled');
      $('.qty-btn-wrapper .product-form__submit.button').addClass('hidden');
      $('.qty-btn-wrapper .product-select-options').addClass('active');
      //$('.qty-btn-wrapper .product-form__submit.button span').html('Select options');
      
      $('#orderdeadline').show();
      $('#dynamicbuttonwrp').show();
    }

    $('.tab-custom-stan-option .tabcontent').fadeOut(100);
    $('.tab-custom-stan-option .tabcontent').removeClass('active');
    $('.tab-custom-stan-option .tabcontent[data-attr="'+atr+'"]').addClass('active');
    $('.tab-custom-stan-option .tabcontent[data-attr="'+atr+'"]').fadeIn(100);
  });

  $('.variant-wrapper.elevate-index-1 select').change(function() {

      var isselectAva1 = $('.variant-wrapper.elevate-index-1 select').find('option[value="Select"]').length;
      var isselectAva2 = $('.variant-wrapper.elevate-index-2 select').find('option[value="Select"]').length;
      var isselectAva3 = $('.variant-wrapper.elevate-index-3 select').find('option[value="Select"]').length;
      // if (isselectAva1 == 0) {
      //   $('.variant-wrapper.elevate-index-1').find('select').prepend('<option disabled value="Select">Select</option>')
      // }
      if (isselectAva2 == 0) {
        $('.variant-wrapper.elevate-index-2').find('select').prepend('<option disabled value="Select">Select</option>')
      }
      if (isselectAva3 == 0) {
        $('.variant-wrapper.elevate-index-3').find('select').prepend('<option disabled value="Select">Select</option>')
      }
    
      $('.variant-wrapper.elevate-index-2').find('select').val('Select');
      $('.variant-wrapper.elevate-index-3').find('select').val("Select");
      $('.qty-btn-wrapper .product-form__submit.button').attr('disabled', 'disabled');
      $('.qty-btn-wrapper .product-form__submit.button').addClass('hidden');
      $('.qty-btn-wrapper .product-select-options').addClass('active');
      //$('.qty-btn-wrapper .product-form__submit.button span').html('Select options');
  });

    $('.variant-wrapper.elevate-index-2 select').change(function() {  

      var isselectAva1 = $('.variant-wrapper.elevate-index-1 select').find('option[value="Select"]').length;
      var isselectAva2 = $('.variant-wrapper.elevate-index-2 select').find('option[value="Select"]').length;
      var isselectAva3 = $('.variant-wrapper.elevate-index-3 select').find('option[value="Select"]').length;
      // if (isselectAva1 == 0) {
      //   $('.variant-wrapper.elevate-index-1').find('select').prepend('<option disabled value="Select">Select</option>')
      // }
      if (isselectAva2 == 0) {
        $('.variant-wrapper.elevate-index-2').find('select').prepend('<option disabled value="Select">Select</option>')
      }
      if (isselectAva3 == 0) {
        $('.variant-wrapper.elevate-index-3').find('select').prepend('<option disabled value="Select">Select</option>')
      }
      
      var op3 = $('.cscst.elevate-index-3').length;
      var op3value = $('.cscst.elevate-index-3 select').val();
      // $('.variant-wrapper.elevate-index-3').css('opacity', '1');
      if (op3 > 0) {
        $('.variant-wrapper.elevate-index-3').find('select').val("Select");
        $('.qty-btn-wrapper .product-form__submit.button').attr('disabled', 'disabled');
        $('.qty-btn-wrapper .product-form__submit.button').addClass('hidden');
        $('.qty-btn-wrapper .product-select-options').addClass('active');
        //$('.qty-btn-wrapper .product-form__submit.button span').html('Select options');
      }
    });

  $(document).on('change', '.custom-options-cont select.variant__input-flex', function(e, data) { 
    if(!data?.tab){
      let flexOption = $(this).val(),
      shaftSelect = $('.custom-options-cont select.variant__input-shaft-options'),
      shaftOptions = shaftSelect.find('option');

      let firstShaftOption = shaftOptions.filter(`[data-flex="${flexOption}"]`).first();

      shaftSelect.val(firstShaftOption.val());
      shaftSelect.trigger('change');

      shaftOptions.each(function() {
        if ($(this).data('flex') === flexOption) {
          $(this).css('display', 'block');
        } else {
          $(this).css('display', 'none');
        }
      });
    }
  });
  
  $(document).on('change', '.custom-options-cont select', function() { 
    // var cprice = $('#hiddenprice').val();
    var cprice = $('.custom_data_product').attr('price');
    if (cprice) {
      cprice = parseFloat(cprice)/100;
    }
    var totalprice = cprice;
    var enableBtn = true;
    $('.custom-options-cont select').each(function() {
      var price = $(this).find('option:selected').attr('vupgradeprice');
      if (!price) {
      	price = 0;
      }
      if (price > 0) {
        price = parseInt(price)/100;
      }
      totalprice = parseInt(totalprice) + parseInt(price);    

      var v = $(this).find('option:selected').val();
      if (v == 'Select') {
        enableBtn = false;
      }
    });
    if (enableBtn) {    
      $('form .product-form__submit').removeAttr('disabled');
      $('.qty-btn-wrapper .product-form__submit.button').removeClass('hidden');
      $('.qty-btn-wrapper .product-select-options').removeClass('active');
      if ($('body').hasClass('template-suffix-custom-preorder')) {
        $('.qty-btn-wrapper .product-form__submit.button span').html('Preorder');        
      } else {
        $('.qty-btn-wrapper .product-form__submit.button span').html('Add to basket');
      }
    }
    
    $('.template-suffix-product-custom .product__info-wrapper span.price-item.price-item--regular').text('£'+totalprice.toFixed(2));
    $('.template-suffix-custom-preorder .product__info-wrapper span.price-item.price-item--regular').text('£'+totalprice.toFixed(2));
    
    if ($('.loyalty-rewards-point p .points-count').hasClass('triple')) {
      $('.loyalty-rewards-point p .points-count').text((Math.ceil(totalprice)*3).toFixed(2));
    } else if ($('.loyalty-rewards-point p .points-count').hasClass('double')) {
      $('.loyalty-rewards-point p .points-count').text((Math.ceil(totalprice)*2).toFixed(2));
    } else {
      $('.loyalty-rewards-point p .points-count').text((Math.ceil(totalprice)).toFixed(2));
    }
    
    if ($('.loyalty-rewards-point p .pointprice').hasClass('triple')) {
      $('.loyalty-rewards-point p .pointprice').text(((Math.ceil(totalprice)/100)*3).toFixed(2));
    } else if ($('.loyalty-rewards-point p .pointprice').hasClass('double')) {
      $('.loyalty-rewards-point p .pointprice').text(((Math.ceil(totalprice)/100)*2).toFixed(2));
    } else {
      $('.loyalty-rewards-point p .pointprice').text((Math.ceil(totalprice)/100).toFixed(2));
    }
    if (totalprice <= 30000) {
      var deva = (totalprice / 3);
      var devac = (totalprice / 4);
      if ($('.dynamic_financers').length > 0) {
        $('.dynamic_financers').html('£'+deva.toFixed(2));
        $('.dynamic_financers_clear').html('£'+devac.toFixed(2));
        document.querySelector('klarna-placement').dataset.purchaseAmount = totalprice * 100;
        window.Klarna.OnsiteMessaging.refresh();
      }
    }
  });
  
  var $popup = $("[data-popup]");
  $(document).on('click', 'button.close-proceed', function(){
    $popup.slideUp(240); 
    $('body').removeClass('data-popup');
  });

   if ($('body').hasClass('pingpopup') && $('body').hasClass('template-product')) {
      var n = 1
      var $popup = n ? $("[data-popup='"+n+"']") : $(this).closest("[data-popup]");
      $popup.slideToggle(240);
      $('body').addClass('data-popup');
    }

    // $('div[data-address] button').click(function(params) {
    //   var atr = $(this).attr('aria-controls');
    //   $(this).attr('aria-expanded') == 'false' ? $(this).attr('aria-expanded', 'true') : $(this).attr('aria-expanded', 'false');
    // })
      var qtyInventory = parseInt($('.product__inventory').attr('datavalue'));
      if (qtyInventory > 0) {
        $('.quantity__input').attr('max', qtyInventory);
      }

  function renderSelectElements(t, s) {
    setTimeout(() => {
      $('variant-selects .select__select').each(function (index, element) {  
          var a = '';
          var that = $(this);
          $(element).each(function (idx, elm) {
              $('option', elm).each(function (id, el) {
                  var cs = $(this).attr('class');
                  var vl = $(this).attr('value');
                  a += '<li class="'+cs+'" value="'+vl+'">' + el.text + '</li>';
              });
              that.parent('.select').find('.scrollableList').find('ul').html(a);
              $('.scrollableList ul').hide();
              that.parent('.select').find('.scrollableList').find('.makeMeUl').children('div.selectedOption').text("Select");
          });
          // $('.scrollableList:last').children('div.selectedOption').text("Select");
      });      
          if (t) {
            $('.elevate-index-2').find('.scrollableList').children('div.selectedOption').text("Select");
            $('.elevate-index-3').find('.scrollableList').children('div.selectedOption').text("Select");
          }
          if (s) {
            $('.elevate-index-3').find('.scrollableList').children('div.selectedOption').text("Select");
          }
    }, 105);
  }
  

    $('variant-selects .select__select').each(function (index, element) {
        $(this).parent()
            .after()
            .append("<div class='scrollableList'><div class='selectedOption'></div><ul></ul></div>");

        $(element).each(function (idx, elm) {
            $('option', elm).each(function (id, el) {
              // console.log(id, el, el.target)
                var cs = $(this).attr('class');
                var vl = $(this).attr('valueWithoutQuote');
                $('.scrollableList ul:last').append('<li class="'+cs+'" value="'+vl+'">' + el.text + '</li>');
            });
            $('.scrollableList ul').hide();
            $('.makeMeUl').children('div.selectedOption').text("Select");
        });
        $('.scrollableList:last').children('div.selectedOption').text("Select");
    });

    $(document).on('click', '.selectedOption', function () {
        $(this).next('ul').slideToggle(200);
        $('.selectedOption').not(this).next('ul').hide();
    });

    $(document).on('click', '.scrollableList ul li', function () {
        var selectedLI = $(this).text();
        var v = $(this).attr('value');
        v= v.trim();
        var id = '#'+$(this).parents('.select').find('select.select__select').attr('id');
        $(this).parents('.select').find('select.select__select').val(v);

        var v12 = v.replace("'", '');
        // $(this).parents('.select').find('select.select__select').removeAttr('selected');
        var a = $(this).parents('.select').find('select.select__select option[valuewithoutquote="'+v12+'"]').val();
        $(this).parents('.select').find('select.select__select').val(a);

        $(this).parents('.select').find('select.select__select').trigger('change');
        const e = new Event("change");
        const element = document.querySelector(id);
        // element.dispatchEvent(e);
        
        // var el = document.getElementById('times-input');
        // el.defaultValue=4;
        //console.log(element)
        element.dispatchEvent(new Event("change", { bubbles: true }));
  
        $(this).parent().prev('.selectedOption').text(selectedLI);
        $(this).parents('.select').find('select.select__select').val(a);
      // console.log(v, a);
        var isFirstIndex = $(this).parents('.product-form__input').hasClass('elevate-index-1');
        var isSecondIndex = $(this).parents('.product-form__input').hasClass('elevate-index-2');
        renderSelectElements(isFirstIndex, isSecondIndex);
        $(this).parent('ul').hide();
    });

    $('.scrollableList').show();
    $('variant-selects .select__select').hide();

    $(document).mouseup(function(e) {
      var container = $(".scrollableList ul");
      var parentContainer = $('.scrollableList');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        if (!parentContainer.is(e.target) && parentContainer.has(e.target).length === 0) {
            container.hide();
        }
      }
    });

    let selectOption = document.querySelector(".product-select-options");
    if (selectOption) {
      selectOption.addEventListener("click", function (event) {  
        let productForm = document.querySelector('[data-type="add-to-cart-form"]');
        if (productForm) {
            let offset = productForm.getBoundingClientRect().top + window.scrollY - 130;
            window.scrollTo({ top: offset, behavior: "smooth" });
        }
      });
    }
  
  (function(ns, fetch) {
    if (typeof fetch !== 'function') return;
    ns.fetch = function() {
      const response = fetch.apply(this, arguments);
      response.then(res => {
        if ([
            `${window.location.origin}/cart/update`,
            `${window.location.origin}/cart/update?sca_process_gifts`,          
            `${window.location.origin}/cart/change`,
            `${window.location.origin}/cart/clear`
          ].includes(res.url)) {
          res.clone().json().then(data => {
            setTimeout(function() {
                  $.ajax({
                    type: 'GET',
                    dataType: 'json',
                    url: '/cart.js',
                    success: function(cart){
                        // once you get the data from AJAX API you need to get the latest count
                        let total = cart.item_count;
                        if (total > 0) {
                          $('#cart-icon-bubble').addClass('item-count-active');
                        } else {
                        $('#cart-icon-bubble').removeClass('item-count-active');
                        }
                    }
                  });
              
            }, 500)
          });
        }
      });
  
      return response;
    }  
  }(window, window.fetch))
});


/**
 * BG: Show "add to basket" button when product form is not visible on mobile.
 */
document.addEventListener('DOMContentLoaded', () => {
  // Select required elements
  const productForm = document.querySelector('product-form');
  const stickyButton = document.querySelector('.button-sticky-mobile');
  const footerBoxesWrapper = document.querySelector('.footer-boxes-wrapper');
  const productInfo = document.querySelector('product-info');

  if (!productForm || !stickyButton || !footerBoxesWrapper) {
    console.error('One or more required elements were not found in the DOM.');
    return;
  }

  // State variables to track visibility
  let isProductFormVisible = false;
  let isFooterVisible = false;

  // Function to update the sticky button's class based on visibility states
  function updateStickyButton() {
    // Only add "active" if both productForm and footerBoxesWrapper are not visible.
    if (!isProductFormVisible && !isFooterVisible) {
      stickyButton.classList.add('active');
    } else {
      stickyButton.classList.remove('active');
    }
  }

  // Observer for product-form, adjusted for the 127px sticky header
  const productObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isProductFormVisible = entry.isIntersecting;
      updateStickyButton();
    });
  }, {
    root: null,
    threshold: 0,
    rootMargin: "-127px 0px 0px 0px" // Shifts the top boundary down by 127px
  });

  // Observer for footer-boxes-wrapper; no offset is needed here. Hide the button when the footer comes into view.
  const footerObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isFooterVisible = entry.isIntersecting;
      updateStickyButton();
    });
  }, {
    root: null,
    threshold: 0
  });

  stickyButton.addEventListener('click', () => {
    productInfo.scrollIntoView({ behavior: 'smooth' });
  });

  productObserver.observe(productForm);
  footerObserver.observe(footerBoxesWrapper);
});



document.addEventListener('DOMContentLoaded', () => {
  let isCollection = document.querySelector('body.template-collection');
  window.boostItems = [];
  if (isCollection) {
    let boostMaxRetries = 20;

    let boostChecker = setInterval(() => {
      window.boostItems = document.querySelectorAll('.boost-sd__product-item');

      if(boostMaxRetries <= 0){
        clearInterval(boostChecker);
        return;
      } else {
        boostMaxRetries--;
      }

      if(window.boostItems.length > 0){
        updateBoostItemsBadges();
        let loadMoreButton = document.querySelector('.boost-sd__pagination-button--load-more');
        let loadPreviousButton = document.querySelector('.boost-sd__pagination-button--load-previous');
        loadMoreButton?.addEventListener('click', () => loadMoreBoostItems(boostItems));
        loadPreviousButton?.addEventListener('click', () => loadMoreBoostItems(boostItems));
        clearInterval(boostChecker);
      }
    }, 750);
    
  }

  function loadMoreBoostItems(){
    let loadMoreRetries = 10;
    let loadMoreChecker = setInterval(() => {
      if(loadMoreRetries <= 0){
        clearInterval(loadMoreChecker);
        return;
      } else {
        loadMoreRetries--;
      }

      let newBoostItems = document.querySelectorAll('.boost-sd__product-item');

      if(newBoostItems.length > window.boostItems.length){
        updateBoostItemsBadges(newBoostItems);
        window.boostItems = newBoostItems;
        clearInterval(loadMoreChecker);
      }
    }, 500);
  }

  function updateBoostItemsBadges(boostItems){
    let thisBoostItems = boostItems || window.boostItems;
    thisBoostItems.forEach(boostCard => {
      let cap = boostCard.querySelector('.boost-sd__product-price--compare'),
          price = boostCard.querySelector('.boost-sd__product-price--sale'),
          saleBadge = boostCard.querySelector('.boost-sd__product-label--sale'),
          saleBadgeText = saleBadge?.querySelector('.boost-sd__product-label-text');

          if(price?.querySelector('.boost-sd__format-currency')){
            price = price.querySelector('.boost-sd__format-currency');
          }

        if(cap && saleBadge && price){
            let capValue = Number(cap.textContent.replace('£', '').replace(',', '').trim()),
                priceValue = Number(price.textContent.replace('£', '').replace(',', '').replace('From', '').trim());
            
            let savings = (capValue - priceValue).toFixed(2).replace('.00', ''),
                percentageSavings = Math.round((savings * 100) / capValue);

            if(document.body.dataset.saleType === 'percentage'){
              saleBadgeText.textContent = `Save ${percentageSavings}%`;
            } else if(document.body.dataset.saleType === 'money'){
              saleBadgeText.textContent = `Save £${savings}`;
            }

            saleBadge.classList.add('active');
        }
    });
  }
});
